import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { FaFacebook, FaInstagram, FaTiktok, FaTwitter, FaYoutube } from "react-icons/fa";
import { IconEmail } from '../../../assets';
import { isColorLight } from '../../../utils/FunctionsGlobals';
import { useAuth } from '../../context/Info';
import styles from './Topo.module.css';

const Topo2: React.FC<{
    site: any;
    setActiveDrawer: any;
    setBuscaAvancada: any;
}> = ({ site, setActiveDrawer,setBuscaAvancada }) => {

    const {
        allDataHome
    } = useAuth();
    const router = useRouter();
    const { codsite } = router.query;
    const logoHeight = Number(site?.id) === 2539 ? 250 : site?.tamanho_logo;
    const [scrolled, setScrolled] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const cor_font_2 = isColorLight(site?.cor2) ? site?.cor11 : site?.cor13;
    const withCodsite = (href: string) => {
        if (!href || !href.startsWith('/') || !codsite) return href;
        const codsiteValue = Array.isArray(codsite) ? codsite[0] : codsite;
        const [base, hash = ''] = href.split('#');
        const [pathname, query = ''] = base.split('?');
        const params = new URLSearchParams(query);
        params.set('codsite', String(codsiteValue));
        const queryString = params.toString();
        const nextHref = queryString ? `${pathname}?${queryString}` : pathname;
        return hash ? `${nextHref}#${hash}` : nextHref;
    };

    /* monta listener só 1 vez */
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 50);
        onScroll();
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const handleSearch = () => {
        if (searchTerm.trim()) {
            router.push(withCodsite(`/imoveis/venda/-/-/-/-/${encodeURIComponent(searchTerm)}`));
        }
    };

    const handleAdvancedSearch = () => {
        if(site?.id == 2379)
            if(setBuscaAvancada)
                setBuscaAvancada(true)
            else
                router.push(withCodsite(`/imoveis/venda/-/-/-/-`));
        else
            router.push(withCodsite('/#myLink'));
    };

    const hexToRgb = (hex: string) => {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    };

    const getBackgroundColor = () => {
        if (scrolled && site?.cor1) {
            const rgb = hexToRgb(site.cor1);
            return rgb ? `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.9)` : site.cor1;
        }
        return 'transparent';
    };

    const getFontColor = () => {
        if (scrolled && site?.cor1) {
            const corletra = isColorLight(site?.cor1) ? site?.cor11 : site?.cor13
            return corletra;
        }
        return 'white';
    };

    const allSocials = [
        {
            href: site?.Dados?.instagram || '',
            id: 3,
            icon: <FaInstagram style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Instagram'
        },
        {
            href: site?.Dados?.facebook || '',
            id: 1,
            icon: <FaFacebook style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Facebook'
        },
        {
            href: site?.Dados?.twitter || '',
            id: 4,
            icon: <FaTwitter style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Twitter'
        },
        {
            href: site?.Dados?.tiktok || '',
            id: 5,
            icon: <FaTiktok style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Tiktok'
        },
        {
            href: site?.Dados?.youtube || '',
            id: 2,
            icon: <FaYoutube style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Youtube'
        },
    ];
    const openDrawer = () => {
        setActiveDrawer(true);
    };
    const trackLeadLazy = () => {
        void import('../../whatsAppButton/WhatsAppButton')
            .then(({ trackLead }) => {
                trackLead(site, null);
            })
            .catch(() => undefined);
    };

    const menusElegiveis = (allDataHome?.menus ?? []).filter((v: any) =>
        v?.Disponivel && (v?.link || (!v?.link && v?.titulo !== "Equipe"))
    )
    .slice(0, 3);

    return (
        <nav className={site?.id == 2379 ? styles.nav1 : styles.nav} style={{ 
            position: 'fixed', 
            top: 0, 
            width: '100%', 
            zIndex: 99,
            background: getBackgroundColor(),
            transition: 'background 0.3s ease'
        }}>
            <div className={`${styles.navContainer} ${site?.id == 2080 ? styles.navContainerLogoCenter2080 : ''}`} style={site?.id == 2379 ? {margin: '0 5%',width: '90%'} : {}}>
                {/* Logo */}
                <Link prefetch={false} href={withCodsite("/")} className={`${styles.navLogoLink} ${site?.id == 2080 ? styles.navLogoLinkCenter2080 : ''}`}>
                    <div className={styles.navLogoContainer}>
                        {site?.url_logo ? (
                            <Image
                                src={`${site?.url_logo}?v=${site?.contador_marca || 0}`}
                                alt={`Imobiliária ${site?.Dados?.empresa}`}
                                title={`Imobiliária ${site?.Dados?.empresa}`}
                                width={250}
                                height={logoHeight > 1 ? logoHeight : 60}
                                style={logoHeight > 1 ? {
                                    width: '100%', 
                                    maxHeight: logoHeight,
                                    height: '100%', 
                                    objectFit: 'contain' 
                                } :  {
                                    width: '100%', 
                                    height: '100%', 
                                    objectFit: 'contain' 
                                }}
                            />
                        ) : (
                            <div className={styles.logo_empty} />
                        )}
                    </div>
                </Link>

                <div className={styles.juntos}>
                {menusElegiveis.map((v, idx) => (
                    <Link
                        prefetch={false}
                        href={withCodsite(v?.link ? v?.link : `/menu/${encodeURIComponent(v?.titulo)}`)}
                        key={v?.titulo ?? idx}
                        className={styles.menus}
                        passHref
                        aria-label={`Botão para navegar ao menu ${v?.titulo}`}
                        title={`Clique aqui para navegar ao menu ${v?.titulo}`}
                    >
                        <div className={styles.info_body} style={{ color: getFontColor() }}>
                            {v?.titulo}
                        </div>
                    </Link>
                    ))}
                {/* Desktop Search - Hidden on mobile */}
                <div className={site?.id == 2379 ? styles.navDesktopSearch1 : styles.navDesktopSearch}>
                    <div className={styles.navSearchContainer}>
                        <input
                            className={styles.navSearchInput}
                            type="search"
                            id="myplace"
                            style={site?.id == 2379 ? {minWidth: 200,width: "100%",border: `1px solid ${cor_font_2}`,color: cor_font_2} : {border: `1px solid ${cor_font_2}`,color: cor_font_2}}
                            placeholder={site?.id == 2379 ? "BUSCA POR NOME OU CÓDIGO" : "BUSCA POR CÓDIGO"}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                        />
                        <style>
                            {`
                            #myplace::placeholder {
                                color: ${getFontColor()};
                            }
                            `}
                        </style>
                        <button 
                            className={styles.navSearchButton}
                            style={{background: site?.cor2,color: cor_font_2,border: `1px solid ${cor_font_2}`}}
                            onClick={handleSearch}
                        >
                            OK
                        </button>
                    </div>
                    <button 
                        className={styles.navAdvancedButton}
                        style={{background: site?.cor2,color: cor_font_2}}
                        onClick={handleAdvancedSearch}
                    >
                        BUSCA AVANÇADA
                    </button>
                </div>
                </div>
                 {/* Menu Button - Desktop */}
                <div style={{display: "flex", alignItems: "center"}}>
                    {site?.redes_topo &&
                    <div className={styles.redes_sociais}>
                        <div className={styles.container1} style={{display: 'flex'}}>
                            {site?.id == "2321" &&
                                <a
                                    rel="noopener noreferrer"
                                    href="mailto:contato@fcaimoveis.com.br"
                                    target='_blank'
                                    title={`Navegar para o email da imobiliária`}
                                    className={styles.adjust_img1}
                                >
                                    <Image
                                        alt={`Imagem Email`}
                                        src={IconEmail}
                                        height={30}
                                        width={30}
                                    />
                                </a>
                            }
                            {allSocials?.map((v) => {
                                if (v) {
                                    if (v.href) {
                                        return (
                                            <a
                                                aria-label={v.href}
                                                rel="noopener noreferrer"
                                                key={v.id}
                                                href={v.href}
                                                title={`Navegar para o ${v.rede} da imobiliária`}
                                                onClick={async (e) => {
                                                    e.preventDefault(); // Evita o redirecionamento automático

                                                    trackLeadLazy(); // Registra o evento Lead

                                                    // Garante que o evento seja enviado antes de abrir o WhatsApp
                                                    setTimeout(() => {
                                                    window.open(
                                                        v.href,
                                                        "_blank"
                                                    );
                                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                                }}
                                                className={styles.adjust_img1}
                                            >
                                                {v.icon}
                                            </a>
                                        );
                                    }
                                    return null;
                                }
                                return null;
                            })}
                        </div>
                    </div>
                    }
                    
                    <div className={styles.navMenuButton} onClick={openDrawer} style={site?.id == 2379 ? {gap: 8} : {}}>
                        <div className={styles.navMenuButtonLine} style={site?.id == 2379 ? {height: 1,width: 50,backgroundColor: getFontColor()} : {backgroundColor: getFontColor()}}></div>
                        <div className={styles.navMenuButtonLine} style={site?.id == 2379 ? {height: 1,width: 50,backgroundColor: getFontColor()} : {backgroundColor: getFontColor()}}></div>
                        <div className={styles.navMenuButtonLine} style={site?.id == 2379 ? {height: 1,width: 50,backgroundColor: getFontColor()} : {backgroundColor: getFontColor()}}></div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Topo2;
